import { useState } from 'react'
import { supabase } from '../lib/supabase'
import { useAuth } from '../context/AuthContext'
import { track } from '../lib/analytics'

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || 'https://hireit-production-ac0f.up.railway.app'

// "Confirm your email" prompt for owners. Email verification is only needed
// before accepting a booking — listings go live without it. Shown in
// My Listings, My Bookings and when an unverified owner taps Accept.
export default function VerifyEmailPrompt({ reason = 'accept', style }) {
const { user } = useAuth()
const [status, setStatus] = useState('idle') // idle | sending | sent | error

const send = async () => {
setStatus('sending')
track('verify_email_send', { reason })
try {
const { data: { session } } = await supabase.auth.getSession()
const res = await fetch(`${BACKEND_URL}/send-verification`, {
method: 'POST',
headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${session?.access_token}` },
})
setStatus(res.ok ? 'sent' : 'error')
} catch {
setStatus('error')
}
}

return (
<div style={{ background: 'var(--amber-light)', border: '1px solid var(--amber)', borderRadius: 12, padding: '12px 14px', fontSize: 13, color: 'var(--navy)', lineHeight: 1.5, ...style }}>
<div style={{ fontWeight: 700, marginBottom: 4 }}>📩 Confirm your email to accept bookings</div>
<div style={{ color: 'var(--text-muted)', marginBottom: 10 }}>
Your listings are live and hirers can send requests. Before you can accept one, please confirm your email address{user?.email ? <> (<strong>{user.email}</strong>)</> : null} using the link we email you.
</div>
{status === 'sent' ? (
<div style={{ color: 'var(--green)', fontWeight: 600 }}>✅ Sent — check your inbox (and junk folder) for an email from HireIt.</div>
) : (
<button className="btn btn-primary btn-sm" onClick={send} disabled={status === 'sending'}>
{status === 'sending' ? 'Sending…' : 'Email me the confirmation link'}
</button>
)}
{status === 'error' && <div className="form-error" style={{ marginTop: 6 }}>Couldn't send the email just now — please try again.</div>}
</div>
)
}
